import { createContext } from 'react';
import { State, createState } from '@hookstate/core';

export const touchedContext = createContext<State<Record<string, boolean>>>(createState<Record<string, boolean>>({}));
